/* Lovy Studios popup — zie snippets/lovy-popup.liquid voor de toelichting. */
(function(){
  var KEY_DISMISS = 'lovyPopDismissedAt';
  var KEY_DONE = 'lovyPopDone';
  var KEY_PENDING = 'lovyPopPending';
  var KEY_TAB_TOP = 'lovyPopTabTop'; // hoogte van het tabje, als % van de viewport
  var KEY_TAB_CLOSED = 'lovyPopTabClosedAt'; // kruisje boven het tabje gebruikt
  var DISMISS_DAYS = 30;
  var TAB_CLOSE_DAYS = 7; // zo lang blijft het tabje weg na het kruisje
  var DELAY_MS = 5000;

  var pop = document.getElementById('lovy-pop');
  if (!pop) return;
  if (window.Shopify && window.Shopify.designMode) return;
  var path = window.location.pathname;
  if (path.indexOf('/cart') === 0 || path.indexOf('/challenge') === 0) return;

  function safeGet(k){ try { return window.localStorage.getItem(k); } catch(e){ return null; } }
  function safeSet(k,v){ try { window.localStorage.setItem(k,v); } catch(e){} }

  // Lovy 2 okt 2026: meetpunten in Clarity (Filters → Custom events). Doel:
  // scheiden of de popup te weinig mensen BEREIKT (eligible → shown) of te
  // weinig OVERTUIGT (shown → subscribed). Stub = Clarity's eigen wachtrij-
  // patroon, dus ook veilig als clarity.js nog niet geladen is.
  function meet(naam){
    try {
      window.clarity = window.clarity || function(){ (window.clarity.q = window.clarity.q || []).push(arguments); };
      window.clarity('event',  naam);
    } catch(e){}
  }

  // "Klein scherm" = aanraakbediening OF een smal venster. Alleen op pointer
  // afgaan is niet genoeg: een telefoon in bureaublad-modus meldt zich soms als
  // muisapparaat, en dan zou het toetsenbord alsnog opspringen.
  function isKleinScherm(){
    var smal = false, aanraak = false;
    try {
      smal = window.matchMedia('(max-width: 780px)').matches;
      aanraak = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
    } catch(e) { aanraak = 'ontouchstart' in window; }
    return smal || aanraak;
  }

  var ANIM_MS = 450;
  var closeTimer = null;
  var kopieerTimer = null;
  var tab = document.getElementById('lovy-pop-tab');
  var tabWrap = document.getElementById('lovy-pop-tabwrap') || tab;
  var tabX = document.getElementById('lovy-pop-tab-close');
  var tabTimer = null;

  function isIngeschreven(){ return safeGet(KEY_DONE) === '1'; }
  function isTabWeggeklikt(){
    var t = parseInt(safeGet(KEY_TAB_CLOSED) || '0', 10);
    return !!t && (Date.now() - t) < TAB_CLOSE_DAYS * 864e5;
  }

  function showTab(){
    if (!tabWrap) return;
    // Kruisje gebruikt? Dan blijft het tabje TAB_CLOSE_DAYS dagen weg.
    if (isTabWeggeklikt()) return;
    // Ook ná inschrijven blijft het tabje staan: het is dan de enige plek waar
    // iemand zijn kortingscode kan terugvinden nadat hij de popup wegklikte.
    if (tabTimer) { window.clearTimeout(tabTimer); tabTimer = null; }
    tabWrap.classList.add('is-shown');
    herklemTab();   // nu pas is offsetHeight echt, zie herklemTab hierboven
    window.requestAnimationFrame(function(){
      window.requestAnimationFrame(function(){ tabWrap.classList.add('is-visible'); });
    });
  }
  function hideTab(){
    if (!tabWrap) return;
    tabWrap.classList.remove('is-visible');
    tabTimer = window.setTimeout(function(){
      tabWrap.classList.remove('is-shown');
      tabTimer = null;
    }, ANIM_MS);
  }
  // Kruisje: tabje weg, popup-regels ongemoeid. stopPropagation zodat de klik
  // niet via de wrapper alsnog als "open" telt.
  if (tabX) tabX.addEventListener('click', function(e){
    e.stopPropagation();
    safeSet(KEY_TAB_CLOSED, String(Date.now()));
    hideTab();
  });

  function open(){
    if (closeTimer) { window.clearTimeout(closeTimer); closeTimer = null; }
    hideTab();
    // Al ingeschreven? Dan opent het tabje meteen de code, niet opnieuw het
    // formulier. (toonSucces is een functiedeclaratie en dus al beschikbaar.)
    if (isIngeschreven()) { toonSucces(false); }
    pop.hidden = false;
    pop.classList.add('is-open');
    // Eén frame wachten zodat de browser de begin-staat (opacity 0) vastlegt
    // vóór .is-visible de transitie start — anders verschijnt hij alsnog abrupt.
    window.requestAnimationFrame(function(){
      window.requestAnimationFrame(function(){ pop.classList.add('is-visible'); });
    });
    // Lovy 5 sep 2026: GEEN autofocus meer, ook niet op desktop. Shopify hangt
    // hCaptcha aan elk customer-formulier en laadt die bundel (~2 MB) zodra het
    // veld focus krijgt — dat gebeurde dus op élke desktop-paginaweergave na 5 s,
    // ook voor wie de popup meteen wegklikte. De bezoeker klikt het veld zelf aan.
    document.addEventListener('keydown', onKey);
  }
  function close(){
    pop.classList.remove('is-visible');
    document.removeEventListener('keydown', onKey);
    if (!isIngeschreven()) meet('popup_closed');
    safeSet(KEY_DISMISS, String(Date.now()));
    closeTimer = window.setTimeout(function(){
      pop.classList.remove('is-open');
      pop.hidden = true;
      closeTimer = null;
      showTab();
    }, ANIM_MS);
  }
  function onKey(e){ if (e.key === 'Escape') close(); }

  pop.addEventListener('click', function(e){
    if (!e.target.closest) return;
    if (e.target.closest('[data-lovy-pop-close]')) { close(); return; }
    var copyBtn = e.target.closest('[data-lovy-pop-copy]');
    if (copyBtn) {
      var code = copyBtn.getAttribute('data-code') || '';
      var hint = pop.querySelector('[data-lovy-pop-hint]');
      var done = function(){
        copyBtn.classList.add('is-copied');
        if (hint) hint.textContent = 'Copied!';
        // "Copied!" blijft 5 seconden staan en gaat dan terug naar de
        // uitnodiging, zodat het daarna opnieuw kan.
        if (kopieerTimer) window.clearTimeout(kopieerTimer);
        kopieerTimer = window.setTimeout(function(){
          copyBtn.classList.remove('is-copied');
          if (hint) hint.textContent = 'Tap to copy';
          kopieerTimer = null;
        }, 5000);
      };
      var fallback = function(){
        var ta = document.createElement('textarea');
        ta.value = code; ta.setAttribute('readonly',''); ta.style.position = 'absolute'; ta.style.left = '-9999px';
        document.body.appendChild(ta); ta.select(); ta.setSelectionRange(0, code.length);
        var ok = false;
        try { ok = document.execCommand('copy'); } catch(err){}
        document.body.removeChild(ta);
        if (ok) { done(); } else if (hint) { hint.textContent = 'Select the code to copy'; }
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(fallback);
      } else {
        fallback();
      }
    }
  });

  // ---- Tabje: tik = openen, verticaal slepen = verplaatsen ---------------
  // De rand blijft vast (mobiel rechts, desktop links); alleen de hoogte
  // verschuift. Percentage i.p.v. pixels zodat dezelfde plek klopt op elk
  // schermformaat. De klem houdt het tabje volledig binnen beeld.
  function klemTabTop(pct){
    var vh = window.innerHeight || 1;
    // offsetHeight is 0 zolang de wrapper display:none is; ~125px (kruisje +
    // balk) is de gebruikelijke hoogte en dient hier als terugval.
    var hoogte = ((tabWrap && tabWrap.offsetHeight) || 125);
    var half = (hoogte / 2 + 6) / vh * 100;
    // Ook onder de (sticky) header blijven: bovenin geparkeerd overlapt het
    // icoontje anders het cart-icoon, en dan opent een tik de popup i.p.v. de
    // cart (live gereproduceerd, 21 aug 2026). Header weg-gescrold (bottom<=0)
    // of verdacht hoog? Dan geldt gewoon de schermrand-klem.
    var minPct = half;
    var kop = document.querySelector('header');
    if (kop) {
      var kb = kop.getBoundingClientRect().bottom;
      if (kb > 0 && kb < vh / 2) minPct = Math.max(minPct, (kb + hoogte / 2 + 6) / vh * 100);
    }
    return Math.max(minPct, Math.min(100 - half, pct));
  }

  // Opnieuw klemmen op de HUIDIGE schermhoogte (21 sep 2026).
  // Twee fouten stapelden hier op elkaar:
  //  1. klemTabTop draaide bij herstel terwijl de wrapper nog display:none is,
  //     dus offsetHeight = 0 en de terugval van 125px werd gebruikt. De echte
  //     hoogte is 132px (768) tot 146px (1024) — de klem was dus te ruim.
  //  2. Er was GEEN resize/orientationchange-listener. De bewaarde positie is
  //     een percentage, geklemd op de schermhoogte van dat moment. Draait een
  //     iPad van staand (1024 hoog) naar liggend (768), dan klopt die klem niet
  //     meer en steekt het tabje deels buiten beeld: je ziet dan alleen het
  //     MIDDEN van "GET 10% OFF" — oftewel "10%".
  // Zodra het tabje zichtbaar is klopt offsetHeight wel, dus herklemmen we na
  // het tonen en bij elke maat- of orientatiewijziging.
  function herklemTab(){
    if (!tabWrap) return;
    var v = parseFloat(tabWrap.style.getPropertyValue('--lovy-tab-top'));
    if (!isFinite(v)) v = 50;
    tabWrap.style.setProperty('--lovy-tab-top', klemTabTop(v).toFixed(2) + '%');
  }
  window.addEventListener('resize', herklemTab, { passive: true });
  window.addEventListener('orientationchange', herklemTab, { passive: true });

  // Opgeslagen hoogte meteen toepassen, vóór het tabje zichtbaar wordt.
  if (tab) {
    var bewaard = parseFloat(safeGet(KEY_TAB_TOP) || '');
    if (isFinite(bewaard)) tabWrap.style.setProperty('--lovy-tab-top', klemTabTop(bewaard).toFixed(2) + '%');
  }

  // tabGesleept onderdrukt de click die (met een muis) ná het slepen alsnog
  // afvuurt — anders zou elke verplaatsing ook meteen de popup openen.
  var tabGesleept = false;

  if (tab) tab.addEventListener('click', function(){
    if (tabGesleept) { tabGesleept = false; return; }
    meet('popup_tab_open');
    open();
  });

  if (tab && window.PointerEvent) (function(){
    var st = null; // actieve sleep-sessie

    tab.addEventListener('pointerdown', function(e){
      if (!e.isPrimary) return;
      tabGesleept = false;
      // Capture meteen claimen: een muis heeft (anders dan touch) géén implicit
      // capture, en het smalle tabje is na één flinke muisstap alweer verlaten —
      // zonder capture komt er dan nooit een pointermove meer binnen.
      try { tab.setPointerCapture(e.pointerId); } catch(err){}
      st = { id: e.pointerId, x0: e.clientX, y0: e.clientY };
    });

    tab.addEventListener('pointermove', function(e){
      if (!st || e.pointerId !== st.id) return;
      if (!tabGesleept) {
        // Drempel van 8px: daaronder telt het als tik, niet als sleep.
        if (Math.abs(e.clientX - st.x0) < 8 && Math.abs(e.clientY - st.y0) < 8) return;
        tabGesleept = true;
      }
      tabWrap.style.setProperty('--lovy-tab-top', klemTabTop(e.clientY / (window.innerHeight || 1) * 100).toFixed(2) + '%');
    });

    function eindigSleep(e){
      if (!st || e.pointerId !== st.id) return;
      st = null;
      if (tabGesleept) {
        var v = parseFloat(tabWrap.style.getPropertyValue('--lovy-tab-top'));
        if (isFinite(v)) safeSet(KEY_TAB_TOP, v.toFixed(2));
      }
    }
    tab.addEventListener('pointerup', eindigSleep);
    // pointercancel + lostpointercapture ook netjes afronden MET opslaan:
    // Chromium kan een muissleep met grote sprongen halverwege cancelen
    // (E2E-gemeten, 21 aug 2026) — zonder opslaan staat het icoontje dan
    // zichtbaar op plek A maar springt het na een reload terug naar plek B.
    // Na een normale pointerup is st al null en zijn beide no-ops.
    tab.addEventListener('pointercancel', eindigSleep);
    tab.addEventListener('lostpointercapture', eindigSleep);
  })();

  // ---- Inschrijven zonder de pagina te herladen -------------------------
  var form = pop.querySelector('form');
  var bezig = false;

  // markeren=true bij een verse inschrijving; false wanneer we de code alleen
  // opnieuw tonen omdat iemand via het tabje terugkomt.
  function toonSucces(markeren){
    var tpl = document.getElementById('lovy-pop-success-tpl');
    var body = pop.querySelector('.lovy-pop__body');
    if (!tpl || !body) return false;
    if (!body.querySelector('.lovy-pop__code')) {
      body.innerHTML = '';
      body.appendChild(tpl.content.cloneNode(true));
      if (markeren) body.classList.add('lovy-pop--fresh');
    }
    if (markeren) safeSet(KEY_DONE, '1');
    return true;
  }

  function toonFout(bericht){
    if (!form) return;
    var oud = form.querySelector('.lovy-pop__error');
    if (oud) oud.remove();
    var p = document.createElement('p');
    p.className = 'lovy-pop__error';
    p.setAttribute('role', 'alert');
    p.textContent = bericht;
    var rij = form.querySelector('.lovy-pop__row');
    if (rij && rij.parentNode) { rij.parentNode.insertBefore(p, rij.nextSibling); }
    else { form.appendChild(p); }
  }

  if (form) form.addEventListener('submit', function(e){
    // Vlag gezet? Dan is dit de bewuste terugval naar een gewone verzending.
    if (form.getAttribute('data-native') === '1') {
      try { window.sessionStorage.setItem(KEY_PENDING, '1'); } catch(err){}
      return;
    }
    // Dubbele verzending blokkeren. De vlag staat op het formulier zelf en niet
    // in een scriptvariabele: dat blijkt de enige die standhoudt wanneer twee
    // kliks direct achter elkaar komen (gemeten: variabele liet er 2 door).
    if (form.getAttribute('data-busy') === '1') { e.preventDefault(); return; }

    if (!window.fetch || !window.FormData) {
      try { window.sessionStorage.setItem(KEY_PENDING, '1'); } catch(err){}
      return; // oude browser: laat de gewone verzending zijn werk doen
    }

    e.preventDefault();
    if (bezig) return;
    bezig = true;
    form.setAttribute('data-busy', '1');

    var knop = form.querySelector('button[type="submit"]');
    var label = knop ? knop.textContent : '';
    if (knop) { knop.disabled = true; knop.textContent = 'Sending…'; }

    function terugNaarFormulier(){
      bezig = false;
      form.removeAttribute('data-busy');
      if (knop) { knop.disabled = false; knop.textContent = label; }
    }

    function natieveVerzending(){
      form.setAttribute('data-native', '1');
      try { window.sessionStorage.setItem(KEY_PENDING, '1'); } catch(err){}
      form.submit();
    }

    // Rechtstreeks naar Klaviyo (geen captcha, geen herlaad); Shopify-route
    // blijft het vangnet via natieveVerzending().
    var invoer = form.querySelector('input[type="email"]');
    var email = invoer ? invoer.value.trim() : '';
    window.fetch('https://a.klaviyo.com/client/subscriptions/?company_id=SbF7XN', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2025-07-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: {
        custom_source: 'Popup WELCOME10',
        profile: { data: { type: 'profile', attributes: { email: email } } } },
        relationships: { list: { data: { type: 'list', id: 'Rix4hy' } } } } })
    }).then(function(res){
      if (res.ok || res.status === 202) {
        // Lovy 30 sep: browser aan het Klaviyo-profiel koppelen (browse-abandonment werkt dan ook voor popup-leads)
        try { window._learnq = window._learnq || []; window._learnq.push(['identify', { '$email': email }]); } catch (err) {}
        meet('popup_subscribed');
        if (!toonSucces(true)) { natieveVerzending(); }
        return;
      }
      natieveVerzending();
    }).catch(function(){
      terugNaarFormulier();
      toonFout('Something went wrong. Please try again.');
    });
  });

  // Succes-staat: Shopify redirect met ?customer_posted=true na de POST.
  // Alleen heropenen als de inzending uit deze popup kwam (niet uit de footer).
  var posted = window.location.search.indexOf('customer_posted=true') !== -1;
  var pending = false;
  try { pending = window.sessionStorage.getItem(KEY_PENDING) === '1'; } catch(e){}
  if (posted && pending) {
    try { window.sessionStorage.removeItem(KEY_PENDING); } catch(e){}
    safeSet(KEY_DONE, '1');
    meet('popup_subscribed');
    // Adresbalk opschonen: ?customer_posted=true (en de #lovy-pop-form-anker)
    // weghalen zodat de bezoeker niets ziet veranderen aan zijn eigen pagina.
    if (window.history && window.history.replaceState) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete('customer_posted');
        url.hash = '';
        window.history.replaceState({}, '', url.pathname + url.search);
      } catch(e){}
    }
    open();
    return;
  }

  // Al ingeschreven: niet opnieuw met de popup in het gezicht springen, maar wel
  // het tabje tonen — daarachter zit hun kortingscode.
  if (isIngeschreven()) { showTab(); return; }

  // Eerder weggeklikt: de popup zelf niet opnieuw opdringen, maar wel het
  // tabje tonen zodat de aanbieding bereikbaar blijft.
  var dismissedAt = parseInt(safeGet(KEY_DISMISS) || '0', 10);
  if (dismissedAt && (Date.now() - dismissedAt) < DISMISS_DAYS * 864e5) { showTab(); return; }

  // ────────────────────────────────────────────────────────────────────
  // Popup-timing, 14 sep 2026. Was: blind na 5 s, ongeacht waar de bezoeker
  // was en of de cookiebanner nog openstond. Op mobiel lagen dan twee lagen
  // over dezelfde koopknop. Nu:
  //   1. altijd wachten tot de cookiebanner weg is (keuze gemaakt of geen
  //      banner van toepassing);
  //   2. op productpagina's daarna pas bij 40% scroll of na 20 s — daar is
  //      de koopknop het doel, niet het inschrijfformulier;
  //   3. elders zoals voorheen 5 s na de cookiekeuze.
  // Terugdraaien = dit blok vervangen door window.setTimeout(open, DELAY_MS).
  var SCROLL_DEEL = 0.4;
  var PDP_DELAY_MS = 20000;
  var BANNER_GRACE_MS = 2500;
  var isPdp = path.indexOf('/products/') === 0;

  // De banner is van Shopify zelf (#shopify-pc__banner) en wordt ná het thema
  // geïnjecteerd. Hoogte 0 = weggeklikt of nooit getoond.
  function bannerWeg(){
    var b = document.getElementById('shopify-pc__banner');
    return !b || b.getBoundingClientRect().height === 0;
  }

  function naCookiekeuze(cb){
    // Eerst de injectie afwachten, anders lezen we "nog geen banner" als
    // "keuze al gemaakt" en springt de popup alsnog te vroeg open.
    window.setTimeout(function(){
      if (bannerWeg()) { cb(); return; }
      var t = window.setInterval(function(){
        if (bannerWeg()) { window.clearInterval(t); cb(); }
      }, 400);
    }, BANNER_GRACE_MS);
  }

  function autoOpen(){ meet('popup_shown'); open(); }
  meet('popup_eligible');
  naCookiekeuze(function(){
    if (!isPdp) { window.setTimeout(autoOpen, DELAY_MS); return; }
    var afgevuurd = false;
    function vuur(){
      if (afgevuurd) return;
      afgevuurd = true;
      window.removeEventListener('scroll', bijScroll);
      autoOpen();
    }
    function bijScroll(){
      var rek = document.documentElement.scrollHeight - window.innerHeight;
      if (rek <= 0 || (window.scrollY / rek) >= SCROLL_DEEL) vuur();
    }
    window.addEventListener('scroll', bijScroll, { passive: true });
    window.setTimeout(vuur, PDP_DELAY_MS);
  });
})();
